<template>
  <div
    v-editable="blok"
    class="video-and-text-hero"
    :class="[blok.flip_content && 'video-and-text-hero--flipped']"
  >
    <div class="video-and-text-hero__layout">
      <div class="video-and-text-hero__content">
        <div class="video-and-text-hero__content-text">
          <CustomRTE :blok="blok.text[0]" class="video-and-text-hero__text" />
          <CTAGroup
            v-if="blok.links && blok.links.length > 0"
            :ctas="blok.links"
            class="video-and-text-hero__links"
          />
        </div>
      </div>
      <div class="video-and-text-hero__video">
        <iframe
          width="100%"
          :src="videoID"
          controls="0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ImageAndVideoBlokProps } from '@/types';

// Props
const props = defineProps<{
  blok: ImageAndVideoBlokProps;
}>();

const videoID = computed(() => {
  if (props.blok.videoURL.startsWith('https://www.youtube.com/watch?v=')) {
    return (
      'https://www.youtube.com/embed/' +
      props.blok.videoURL.split('=')[1] +
      '?rel=0'
    );
  } else if (props.blok.videoURL.startsWith('https://youtu.be/')) {
    return (
      'https://www.youtube.com/embed/' +
      props.blok.videoURL.split('/')[3] +
      '?rel=0'
    );
  }
});
</script>

<style lang="scss">
.video-and-text-hero {
  &__layout {
    @include container;
    padding-block: var(--spacing-l);
    column-gap: columns(0.75);
    display: grid;
  }

  &__content {
    margin-block-start: var(--spacing-s);
    width: 100%;
  }

  &__video {
    width: 100%;
    iframe {
      margin-inline-start: auto;
      min-height: 340px;
    }
  }

  &__links {
    margin-block-start: var(--spacing-s);
  }

  @media all and #{$mq-s-max} {
    .video-and-text-hero__content {
      margin-block-start: 0;
      margin-block-end: var(--spacing-s);
      order: 0;
    }
  }
}

@media all and #{$mq-m-min} {
  .video-and-text-hero {
    padding-inline-end: 0;
    padding-inline-start: 0;

    &__layout {
      align-items: center;
      grid-template-columns: columns(10) columns(11);
    }

    &__content {
      margin-block-start: 0;
    }

    &--flipped {
      .video-and-text-hero__content {
        order: 1;
      }

      .video-and-text-hero__layout {
        grid-template-columns: columns(10) columns(10);
      }
    }
  }
}

@media all and #{$mq-l-min} {
  .video-and-text-hero {
    &__content {
      position: relative;
    }

    &--flipped {
      .video-and-text-hero__content {
        .picture {
          margin-inline: columns(3) 0;
        }
      }
    }
  }
}
</style>
